import React from 'react';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';

import { Divider } from 'components/common/Divider/Divider';

import './hero-role-divider.scss';

export function HeroRoleDivider(): JSX.Element {
  return (
    <Flex className="hero-role-divider" direction="column">
      <Divider orientation="horizontal" />
      <div className="hero-role-divider-icon">
        <div className="hero-role-divider-icon-arrow" />
      </div>
    </Flex>
  );
}
